import React from 'react';
import Header from "../components/Header";
import ViewEvents from '../components/ViewEvents';
import UserTabs from '../components/UserTabs';
import {ChakraProvider, theme, Flex } from '@chakra-ui/react';
//  (this.props.navigator !== undefined) ? this.props.navigator.history.goBack() : window.location.pathname = '/pro/edit-list';}}/>
const HomePage = ( props => {
    return(
        <React.Fragment>
            <ChakraProvider theme={theme}>
                <Flex className="screen-detect-cntr" justifyContent="center" alignItems="center" flexFlow="column"> 
                <Flex className="screen-detect" flexFlow="column">
                <Header title={"Your Photos"}/>
                <ViewEvents/>
                <UserTabs {...props} />
                </Flex>
                </Flex>
            </ChakraProvider>
        </React.Fragment>
    )
})

export default HomePage;
